import "./App.css";
import DockDashboard from "./components/dashboard/dock-dashboard";
import GateDashboard from "./components/dashboard/gate-dashboard";
import ConfigDashboard from "./components/dashboard/config-dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignageWidgets from "./components/signage/slide-widget";
import GateNewDashboard from "./components/dashboard/gateNew/gate-new-dashboard";
import DockWebDashboard from "./components/dashboard/dock-web/Default";
import VisitorDashboard from "./components/dashboard/gateNew/visitor-dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<SignageWidgets />} />
          <Route path="/gate" element={<GateDashboard />} />
          <Route path="/gate-new" element={<GateNewDashboard />} />
          <Route path="/dock" element={<DockDashboard />} />
          <Route path="/dock-new" element={<DockWebDashboard />} />
          <Route path="/visitor" element={<VisitorDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
